module.exports = __webpack_public_path__ + "img/soft-c-5.c0b96ced.png";